module.exports = __webpack_public_path__ + "img/prize1.e52a483.png";